import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { toDateOnly } from './emission-date.validator';

export function harvestYearWithinPeriodValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value == null || control.value === '') {
      return null;
    }

    const parent = control.parent;
    if (!parent) {
      return null;
    }

    return getHarvestYearPeriodValidation(
      control.value,
      parent.get('startDate')?.value,
      parent.get('endDate')?.value,
    );
  };
}

export function getHarvestYearPeriodValidation(
  harvestYear: unknown,
  startDate: unknown,
  endDate: unknown,
): ValidationErrors | null {
  const year = Number(harvestYear);
  const periodStart = toDateOnly(startDate);
  const periodEnd = toDateOnly(endDate);

  if (!Number.isFinite(year) || year <= 0 || !periodStart || !periodEnd) {
    return null;
  }

  const startYear = periodStart.getFullYear();
  const endYear = periodEnd.getFullYear();

  if (year < startYear) {
    return { harvestBeforePeriod: true };
  }

  if (year > endYear) {
    return { harvestAfterPeriod: true };
  }

  return null;
}

export function isHarvestYearWithinPeriod(
  harvestYear: unknown,
  startDate: unknown,
  endDate: unknown,
): boolean {
  return getHarvestYearPeriodValidation(harvestYear, startDate, endDate) == null;
}
